import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddModelModal from '../../containers/global-settings/AddModelModal'
import EditModelModal from './EditModelModal'
import RemoveModelModal from '../../containers/global-settings/RemoveModelModal'
import ModelList from './ModelList'
import { IVehicleMake } from 'src/types'
import BackToList from '../ui/BackToList'

interface IModelPaneProps extends RouteComponentProps {
  makes: IVehicleMake[]
}

export default class ModelPane extends React.Component<IModelPaneProps> {
  public render() {
    const list: { list: any[]; letters: any[] } = this.getSettingsList()
    console.log(list)

    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddModelModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveModelModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditModelModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Model</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/model/create'
            >
              <Plus className='svg-white mr1' />
              Add Model
            </Link>
          </div>
          <hr />
          <div className='mb2 pl2 font-black h5 bold'>Index</div>
          <div className='mb2 pl2 font-black h4'>
            {list.letters.map(item => (
              <Link className='mr1 font-black' to={`#model-group-${item}`}>
                {item}
              </Link>
            ))}
          </div>
          <hr />
          <div>
            <div className='pl3 pr3'>
              <ModelList baseUrl={this.props.match.path} settingsGroup={list.list} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  private getSettingsList = (): { list: any[]; letters: any[] } => {
    const makes = {}
    const makeGroupCategory = (name: string, models: any[]) => {
      const item: any = {
        groupCategory: name,
        items: []
      }
      // for each make we add all the models
      for (const j of Object.keys(models)) {
        const model = models[j]
        item.items.push({
          label: model.name,
          id: model.id
        })
      }
      return item
    }
    // sort by first character of the make first
    for (const i of Object.keys(this.props.makes)) {
      const make = this.props.makes[i]
      const fc = make.name.charAt(0).toUpperCase()
      if (!makes[fc]) {
        makes[fc] = {
          groupCategory: fc,
          items: []
        }
      }
      makes[fc].items.push(makeGroupCategory(make.name, make.models))
    }
    // make array from the dict of makes && make another array of the actual letters used
    const list = []
    const letters = []
    for (const i of Object.keys(makes)) {
      letters.push(i)
      list.push(makes[i])
    }
    return {
      list,
      letters
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ModelPane.tsx